<template>
<div class="chapter">
<div class="inner_page">
<h1>Sommario</h1>
<p><span href="#/c001" title="Link target outside of Sample">Titolo Pagina</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Pagina</span></p>
<p><a href="#/c003">1</a></p>
<p><span href="#/c004" title="Link target outside of Sample">2</span></p>
<p><span href="#/c005" title="Link target outside of Sample">3</span></p>
<p><span href="#/c006" title="Link target outside of Sample">4</span></p>
<p><span href="#/c007" title="Link target outside of Sample">5</span></p>
<p><span href="#/c008" title="Link target outside of Sample">6</span></p>
<p><span href="#/c009" title="Link target outside of Sample">7</span></p>
<p><span href="#/c010" title="Link target outside of Sample">8</span></p>
<p><span href="#/c011" title="Link target outside of Sample">9</span></p>
<p><span href="#/c012" title="Link target outside of Sample">www.stefaniagil.com</span></p>
<p><span href="#/c013" title="Link target outside of Sample">stefaniagiln@gmail.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?37ff7351